import {S} from './strings.mjs';
// Share one site: title (address line), text (street, postcode city, operator) and a link that opens the map
// at this site with its details (/map?site=<id>). Without the Web Share API: link and address to the clipboard.
export const SITE_ID = /^[0-9A-Za-z]{1,16}$/;
export function shareData(m, origin) {
  const url = `${origin}/map?site=${encodeURIComponent(m.id)}`;
  const text = [m.title, m.place, m.operator ? `${S.operatorLabel}: ${m.operator}` : null].filter(Boolean).join('\n');
  return {title: m.shareTitle, text, url};
}
// -> 'shared' | 'cancelled' | 'copied' | 'failed'
export async function shareSite(data, notify, nav = globalThis.navigator, doc = globalThis.document) {
  if (typeof nav?.share === 'function' && (!nav.canShare || nav.canShare(data))) {
    try { await nav.share(data); return 'shared'; }
    catch (error) { if (error?.name === 'AbortError') return 'cancelled'; /* Not allowed here: copy instead. */ }
  }
  const value = `${data.text}\n${data.url}`;
  try { await nav.clipboard.writeText(value); notify(S.linkCopied, 'info'); return 'copied'; }
  catch { /* No async clipboard (older browsers, no focus): try the classic copy command. */ }
  if (legacyCopy(value, doc)) { notify(S.linkCopied, 'info'); return 'copied'; }
  notify(S.copyFailed, 'warn'); return 'failed';
}
export function legacyCopy(value, doc) {
  if (!doc?.createElement || !doc.body) return false;
  const area = doc.createElement('textarea');
  area.value = value; area.setAttribute('readonly', ''); area.style.position = 'fixed'; area.style.opacity = '0';
  doc.body.append(area); area.select();
  try { return doc.execCommand('copy') === true; } catch { return false; } finally { area.remove(); }
}
